import CopyModal from '@atlassian/jira-copy-filters-modal/src/index.tsx';
import type { OperationModalProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { closeCopyFilterModal } from '../../../state/actions/copy-filter-modal/index.tsx';
import type { State } from '../../../state/types.tsx';

const mapStateToProps = (
	initialState: State,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ownProps: OperationModalProps<Record<any, any>>,
) => {
	const onInitiateSuccess = () => {
		ownProps.onDialogShown();
	};
	const onDataRetrieveFailed = () => {
		ownProps.onDataRetrieveFailed();
	};
	const onCopied = () => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	};
	return (_: State) => ({
		id: ownProps.entityId,
		onCancel: ownProps.onCancel,
		onInitiateSuccess,
		onDataRetrieveFailed,
		onCopied,
	});
};
export default connect(mapStateToProps, {
	onCloseCopyFilterModal: closeCopyFilterModal,
})(CopyModal);
